import React, { useState } from 'react'
import './pager.scss'

/**
 * 
 *  <Pager
          page={content.page}
          maxPages={content.total}
          onChangePage={num => {
            handleSetPage(num)
          }}
        />
 * 
 */
export default function Pager({ page = 0, maxPages = 1, onChangePage }) {
  //const [page, setPage] = useState(currentPage)

  const totalItemsToRender = 5
  const halfItemsToRender = Math.floor(totalItemsToRender / 2)
  const reductItemsToStart = page - halfItemsToRender
  const maxStartPage = maxPages - totalItemsToRender
  const startRenderPage = Math.max(
    0,
    Math.min(maxStartPage, reductItemsToStart)
  )
  const totalItemsWillRender = Math.max(
    1,
    Math.min(totalItemsToRender, maxPages)
  )
  const items = new Array(totalItemsWillRender).fill(0).map((_, idx) => {
    const realNum = startRenderPage + idx
    const renderNum = startRenderPage + idx + 1
    return (
      <div
        key={'f-pager__item-' + idx}
        className={'f-pager__item ' + (page === realNum ? '--active' : '')}
        onClick={() => onSetPage(realNum)}
      >
        {renderNum}
      </div>
    )
  })
  const isFirstPage = page <= 0
  const isLastPage = page >= maxPages - 1

  const onSetPage = newpage => {
    onChangePage(newpage)
  }
  const onNext = () => {
    if (isLastPage) {
      return
    }
    if (page < maxPages) {
      onSetPage(page + 1)
    }
  }
  const onPrev = () => {
    if (isFirstPage) {
      return
    }
    if (page > 0) {
      onSetPage(page - 1)
    }
  }

  return (
    <div className="f-pager">
      <a
        role="button"
        className="f-pager__nav  "
        disabled={isFirstPage}
        onClick={onPrev}
      >
        <span className="icon-left"></span>
        {!isFirstPage && <span className="f-pager__nav__text">Anterior</span>}
      </a>
      {items}
      <a
        role="button"
        className="f-pager__nav "
        disabled={isLastPage}
        onClick={onNext}
      >
        {!isLastPage && <span className="f-pager__nav__text">Siguiente</span>}
        <span className="icon-right"></span>
      </a>
    </div>
  )
}
